import { render, staticRenderFns } from "./details.vue?vue&type=template&id=34a5177a&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=34a5177a&prod&lang=scss"
import style1 from "./details.vue?vue&type=style&index=1&id=34a5177a&prod&lang=scss&scoped=true"
import style2 from "./details.vue?vue&type=style&index=2&id=34a5177a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5177a",
  null
  
)

export default component.exports